import { render, staticRenderFns } from "./club-avatar.vue?vue&type=template&id=db4330d4&scoped=true"
import script from "./club-avatar.vue?vue&type=script&lang=js"
export * from "./club-avatar.vue?vue&type=script&lang=js"
import style0 from "./club-avatar.vue?vue&type=style&index=0&id=db4330d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db4330d4",
  null
  
)

export default component.exports